import { CustomerAdvocacyBadgeItemType, CustomerAdvocacyReducerPropsType, PointSystemInfo } from '@/models/customerAdvocacyModels';
import { Paginator, ServerStatus } from '@/models/globalModels';

import { RootState } from '../../rootReducer';
import * as t from '../types';

const globalState: CustomerAdvocacyReducerPropsType = {
  loyaltyStatus: ServerStatus.IDLE,
  pointsStatus: ServerStatus.IDLE,
  badgesStatus: ServerStatus.IDLE,
  pointsData: {} as PointSystemInfo,
};

export type PossibleActions =
  | { type: 'SET_CUSTOMER_ADVOCACY_POINTS'; payload: PointSystemInfo }
  | { type: 'SET_CUSTOMER_ADVOCACY_POINTS_ERROR' }
  | { type: 'CUSTOMER_ADVOCACY_BADGES_FETCH'; payload: Paginator<CustomerAdvocacyBadgeItemType> }
  | { type: 'CUSTOMER_ADVOCACY_BADGES_FETCHING' }
  | { type: 'CUSTOMER_ADVOCACY_BADGES_FETCH_ERROR'; payload: any };

const reducer = (state = globalState, action: PossibleActions): CustomerAdvocacyReducerPropsType => {
  let error;
  switch (action.type) {
    case t.SET_CUSTOMER_ADVOCACY_POINTS:
      const points = Object.assign({}, action.payload);
      return {
        ...state,
        pointsData: points,
        pointsStatus: ServerStatus.FETCH,
      };
    case t.SET_CUSTOMER_ADVOCACY_POINTS_ERROR:
      return {
        ...state,
        pointsStatus: ServerStatus.FETCH_ERROR,
      };

    case t.CUSTOMER_ADVOCACY_BADGES_FETCHING:
      return {
        ...state,
        badgesStatus: ServerStatus.FETCHING,
      };
    case t.CUSTOMER_ADVOCACY_BADGES_FETCH:
      const badges = Object.assign([], action.payload);
      // const tiers = badges.filter((i) => i.is_tier);
      return {
        ...state,
        badgesStatus: ServerStatus.FETCH,
        badgesData: badges,
        // tiers: tiers,
      };
    case t.CUSTOMER_ADVOCACY_BADGES_FETCH_ERROR:
      error = action.payload;
      return {
        ...state,
        badgesStatus: ServerStatus.FETCH_ERROR,
        error: error,
      };

    default:
      return {
        ...state,
      };
  }
};

// SELECTORS
export const selectPointSystemData = (state: RootState): PointSystemInfo => {
  const profile = state.auth.ambassadorProfile;
  if (!profile) return {} as PointSystemInfo;

  const currentTier = profile.loyalty_points_current_tier;
  const nextTier = profile.loyalty_points_next_tier;

  // if its the last tier, use current tier points range
  const pointsForTierEnd = nextTier?.point_threshold || currentTier?.point_threshold || 0;

  return {
    loyalty_points_earned: profile.loyalty_points_earned,
    loyalty_cash_earned: profile.loyalty_points_earned,
    loyalty_points_available: profile.loyalty_points_available,
    loyalty_points_redeemed: profile.loyalty_points_redeemed,
    loyalty_points_expired: profile.loyalty_points_expired,
    loyalty_cash_redeemed: profile.loyalty_cash_redeemed,
    loyalty_cash_expired: profile.loyalty_cash_expired,
    loyalty_cash_available: profile.loyalty_cash_available,
    // Calculated fields
    loyalty_points_tier_end: pointsForTierEnd || 0, //profile.loyalty_points_tier_end,
    loyalty_points_tier_start: currentTier?.points || 0, //profile.loyalty_points_tier_start,
    loyalty_points_current_tier: currentTier,
    loyalty_points_next_tier: nextTier,
  };
};

export default reducer;
